<template>
  <div>
    <vue-autonumeric
      :disabled="disabled"
      class="input is-small"
      style="text-align: right; background-color: #FFF3A3;"
      v-model="value"
      :input="input"
      :options="currency"
      :readonly="readonly"
    />
  </div>
</template>

<script>
import VueAutonumeric from "vue-autonumeric/src/components/VueAutonumeric.vue";

export default {
  components: {
    VueAutonumeric
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: Object,
    input: Function
  },

  data() {
    return {
      number: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 0
      },
      currency: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "$",
        currencySymbolPlacement: "p",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 0
      },
      percentage: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: "%",
        currencySymbolPlacement: "s",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 6,
        allowDecimalPadding: false
      },
      years: {
        digitGroupSeparator: ",",
        decimalCharacter: ".",
        decimalCharacterAlternative: ".",
        currencySymbol: " years",
        currencySymbolPlacement: "s",
        roundingMethod: "U",
        minimumValue: "0",
        decimalPlaces: 6,
        allowDecimalPadding: false
      }
    };
  }
};
</script>

<style lang="css" scoped>
</style>
